module.exports = __webpack_public_path__ + "static/media/brown-background-3x.2229a936.jpg";